export const common = {
  // Navigation
  'nav.home': 'Home',
  'nav.services': 'Services',
  'nav.pricing': 'Pricing',
  'nav.about': 'About',
  'nav.transfers': 'Our Transfers',
  'nav.chambery': 'Chambéry Airport',
  'nav.lyon': 'Lyon Airport',
  'nav.blog': 'Blog',
  'nav.contact': 'Contact',
  'nav.book': 'Book Now',
  'nav.phone': '+33 6 05 60 60 06',

  // Hero Section
  'hero.title': 'Private Transfers to Alpine Ski Resorts',
  'hero.subtitle': 'Premium service from Geneva, Lyon, and Chambéry airports to the most beautiful ski resorts in the Alps',
  'hero.cta.book': 'Book Your Transfer',
  'hero.cta.quote': 'Get a Quote',

  // Services
  'services.title': 'Our Premium Services',
  'services.subtitle': 'Comfort and safety for all your trips',
  'services.airport.title': 'Airport Transfers',
  'services.airport.desc': 'Direct service from Geneva, Lyon, and Chambéry airports',
  'services.private.title': 'Private Transfers',
  'services.private.desc': 'Comfortable vehicles for 1 to 8 passengers',
  'services.24h.title': '24/7 Available',
  'services.24h.desc': 'Service available day and night, 7 days a week',
  'services.tracking.title': 'Flight Tracking',
  'services.tracking.desc': 'We monitor your flight to adjust pickup time',

  // Destinations
  'destinations.title': 'Popular Destinations',
  'destinations.subtitle': 'The most beautiful ski resorts in the Alps',
  'destinations.viewAll': 'View All Destinations',
  'destinations.privateTransfer': 'Private Transfer',

  // Stats
  'stats.clients': 'Satisfied Clients',
  'stats.transfers': 'Transfers Completed',
  'stats.destinations': 'Destinations',
  'stats.experience': 'Years of Experience',

  // Testimonials
  'testimonials.title': 'What Our Clients Say',
  'testimonials.subtitle': 'Thousands of satisfied travelers',

  // FAQ
  'faq.title': 'Frequently Asked Questions',
  'faq.subtitle': 'Everything you need to know about our services',

  // CTA
  'cta.title': 'Ready to Book Your Transfer?',
  'cta.subtitle': 'Get an instant quote and book in just a few clicks',
  'cta.button': 'Get a Free Quote',

  // Footer
  'footer.description': 'Premium private transfer service to Alpine ski resorts. Comfort, safety, and punctuality guaranteed.',
  'footer.services': 'Services',
  'footer.destinations': 'Destinations',
  'footer.company': 'Company',
  'footer.contact': 'Contact',
  'footer.legal': 'Legal Notice',
  'footer.rights': 'All rights reserved',
  'footer.poweredBy': 'Website Builder',

  // Contact
  'contact.title': 'Contact Us',
  'contact.subtitle': 'We are here to answer all your questions',
  'contact.form.name': 'Full Name',
  'contact.form.email': 'Email',
  'contact.form.phone': 'Phone',
  'contact.form.message': 'Your Message',
  'contact.form.submit': 'Send Message',
  'contact.form.success': 'Message sent successfully!',
  'contact.info.title': 'Contact Information',
  'contact.info.phone': 'Phone',
  'contact.info.email': 'Email',
  'contact.info.whatsapp': 'WhatsApp',

  // Booking
  'booking.title': 'Book Your Transfer',
  'booking.from': 'Departure',
  'booking.to': 'Destination',
  'booking.date': 'Date',
  'booking.time': 'Time',
  'booking.passengers': 'Passengers',
  'booking.luggage': 'Luggage',
  'booking.name': 'Full Name',
  'booking.email': 'Email',
  'booking.phone': 'Phone',
  'booking.notes': 'Additional Notes',
  'booking.submit': 'Confirm Booking',
  'booking.success': 'Booking confirmed!',

  // Common
  'common.from': 'From',
  'common.to': 'To',
  'common.price': 'Price',
  'common.duration': 'Duration',
  'common.distance': 'Distance',
  'common.loading': 'Loading...',
  'common.error': 'An error occurred',
};

export default common;
